import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { OrderHeaderURLs } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'

interface ModalDeleteSellOrderAccountProps extends ModalDeleteSellOrderAccountLogicProps {}

const ModalDeleteSellOrderAccount: React.FC<ModalDeleteSellOrderAccountProps> = ({ setOpened, allRowData, ...logic }) => {
    const { t, tVars } = useTwinTranslation()
    const { deleteAccount } = useModalDeleteSellOrderAccountLogic({ setOpened, allRowData, ...logic })

    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={deleteAccount} translations={{
            title: tVars('sureDeleteChapterName', '¿Seguro que quieres eliminar el capítulo {{accountName}}?', { accountName: allRowData?.name || '' }),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo'),
            buttonAccept: t('delete', 'Eliminar'),
            buttonCancel: t('cancel', 'Cancelar')
        }} />
    )
}

interface ModalDeleteSellOrderAccountLogicProps extends ModalEditComponentProps {
    getCompleteData: () => void
    orderHeaderURLs: OrderHeaderURLs
}

const useModalDeleteSellOrderAccountLogic = ({ getCompleteData, orderHeaderURLs, allRowData, setOpened }: ModalDeleteSellOrderAccountLogicProps) => {
    const deleteAccount = useCallback(async () => {
        await twinFetchPostJSON(orderHeaderURLs.deleteAccount, {
            id: allRowData?.id,
            OrderId: allRowData?.OrderId
        })
        getCompleteData()
        setOpened(null)
    }, [orderHeaderURLs, allRowData, setOpened, getCompleteData])
    return { deleteAccount }
}

export default ModalDeleteSellOrderAccount